import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
} from "@cvx/nextpage";
import { Subject } from "rxjs";
import { Component_MAWP } from "../../../services/component_mawp";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CalcTemplate } from "../../../services/calctemplate";
import { Form1 } from "../../../services/form1";
import { LTA_module } from "../../../services/lta_module";
import { BlisterHIC_module } from "../../../services/blisterHIC_module";
import { MatStepper } from "@angular/material/stepper";
import { FormControlsEventProxyService } from "../../../services/formcontrols_eventproxy_service";
import { MatDialog } from "@angular/material/dialog";
import { MatRadioChange } from "@angular/material/radio";
import { VerticalvesselComponent } from "../../type-a-component/verticalvessel/verticalvessel.component";
import { HorizontalvesselComponent } from "../../type-a-component/horizontalvessel/horizontalvessel.component";
import { CarbonsteelandlowalloysteelComponent } from "../../type-a-component/carbonsteelandlowalloysteel/carbonsteelandlowalloysteel.component";
import { HighalloyandnonferroussteelComponent } from "../../type-a-component/highalloyandnonferroussteel/highalloyandnonferroussteel.component";
import { Overlay } from "@angular/cdk/overlay";
import { WarningModalComponent } from "../../warning-modal/warning-modal.component";
import { ComponentEventService } from "projects/fitnessforservice/src/services/component_event.service";


@Component({
    selector: "blisters-and-hic-damage",
    templateUrl: "blisters-and-hic-damage.component.html",
    standalone: false
})
export class BlistersAndHICDamageComponent implements OnInit {
  blistersHIC_formGroup: FormGroup;
  @ViewChild("stepper") private myStepper: MatStepper;
  inspectionDataCalculate: Subject<boolean> = new Subject();
  applicability: string;
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  path: string;
  reevaluSub: any;
     
 //Shameer 
 typeA : number;
 isreevalu = true;
// ComponentTypeData : Data[];
  tooltipText1: string = '';
  tooltipText2: string = '';
  tooltipText3: string = '';
  tooltipText4: string = ''; 
  intUnittype:number;

  public component_mawp = Component_MAWP;

  summary: string;
  inspectionDataResult: string;
  result: string;
  SelectedValue: string;
  isCheckboxDisabled = false;
  isCylAtmradio = true; // always disabled this radio button for the current requirement
  validationList = [];
  basicValidationLabel: string =
    "Following inputs have invalid information.";

  firstFormGroup = this._formBuilder.group({
    applicabilityCheckbox: ["", Validators.requiredTrue],
    typeACheckbox:["",Validators.required],
    radio:["",],
  });
  secondFormGroup = this._formBuilder.group({});
  isLinear = true;

  constructor(
    private NP: NextPageService,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private componentService: ComponentEventService,
    private formControlsEventProxyService: FormControlsEventProxyService
  ) {
    this.BlistersAndHICDamage_Assesment_Setup();
    this.path = activatedRoute.snapshot["_routerState"].url;

    this.blistersHIC_formGroup = this._formBuilder.group({
      radioButton_DI: ["", Validators.required]
    });
      //shameer   
      this.firstFormGroup.get('typeACheckbox').disable();
      this.firstFormGroup.get('applicabilityCheckbox').disable();
  }

  goToComponent() {

    if(((this.firstFormGroup.get('radio').value) != null) &&
    ((this.firstFormGroup.get('applicabilityCheckbox').enabled == true ) ||
    (this.firstFormGroup.get('typeACheckbox').enabled == true))
  )
{
    this.firstFormGroup.controls["applicabilityCheckbox"].markAsDirty({
      onlySelf: true,
    });
    this.firstFormGroup.controls["applicabilityCheckbox"].markAsTouched({
      onlySelf: true,
    });
   
      //shameer
      let typAcheckbox1 = this.firstFormGroup.controls["typeACheckbox"];
      typAcheckbox1.markAsDirty({
        onlySelf: true,
      });
      typAcheckbox1.markAsTouched({
        onlySelf: true,
      });

    this.goNextStep();
  }else{
    this.dialog.open(WarningModalComponent, {
      width: "450px",
      data: {
        warningMessage: [
          "Select an Option to Proceed!..Please.",
        ],
        caption: "FFS: Applicability and Limitations",
        captionCenter: true,
        cancelButtonShow: false,
      },
    });
  }
}

  getApplicabilityCheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("applicabilityCheckbox") as FormControl;
  }

  gettypeAcheckbox_formControl():FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }


  getRadioButton_DI_formControl(): FormControl {
    return this.blistersHIC_formGroup.get("radioButton_DI") as FormControl;
  }

  ngOnInit(): void {
    CalcTemplate.reset_data();
    this.applicability = `  
      <ol>  
        <li>The original design criteria were in accordance with a recognized code or standard.</li>  
        <li>The operating temperature is less than 400°F (204°C) for carbon or low alloy steels, or is below the applicable design curve in API 941, whichever is greater. Damage associated with high temperature hydrogen attack is specifically excluded.</li>  
        <li>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment.</li>  
        <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
        <li>Type A components subject to internal pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness.  Examples are:  
          <ol type="a">  
            <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
            <li>Spherical pressure vessels and storage spheres</li>  
            <li>Spherical, elliptical and torispherical formed heads</li>  
            <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li>  
            <li>Cylindrical atmospheric storage tank shell courses</li>  
          </ol>  
        </li>  
      </ol>  
    `;

    localStorage.setItem('calculationStep', '0'); //this is zero step (Applicability)

    this.formControlsEventProxyService.getBlisterAndHIC_ApplicabilityAndFormEventSubject().subscribe((v) => {
      this.updateFormControls();
      this.firstFormGroup.get('applicabilityCheckbox').enable();
    });
     // shameer- start
     this.formControlsEventProxyService
     .getBlisterHICtypea_ApplicabilityEventSubject()
     .subscribe((v) => {
       this.updatetypeACheckboxToChecked();
       this.firstFormGroup.get('typeACheckbox').enable();
       
     });
     this.formControlsEventProxyService
     .getblisterhictypeAupdateradioSubject()
     .subscribe((v) => {
       this.updateradiobuttonafterimport();
       this.updatetooltip();
     });
    // shameer -end
     this.reevaluSub = this.componentService.reevaluButtonEnabled.subscribe(
      enabled => this.isreevalu = !enabled
    );
  }
  updateradiobuttonafterimport()
  {
    
    this.firstFormGroup.get('radio').patchValue(this.componentService.typearadioselectedValue.toString());
  
  }

  updatetooltip()
  {
   // this.tooltipText1 = this.componentService.typeatypeAinput1val.toString();

    const a1 = this.componentService.typeatypeAinput1val.toString();
    const a2 = this.componentService.typeatypeAinput2val.toString()

    const ut = this.componentService.typeAUnitTypeval.toString();
    const typaPF = this.componentService.typeAresultjsnval.toString();
    
    const Passres = "\n\nThe component meets the Type A screeing criteria";
    const Failres = "\n\nThe component doesn't meet the Type A screeing criteria.";    

    if(this.componentService.typearadioselectedValue.toString()== "1")
    {
      if (ut == "0")
      {
        const l1 = "Vertical Location of the Flaw, H (inch)";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
      
        if(typaPF == "0")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
        }else if(typaPF == "1")
        {
          this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
        }
        
      }
      else if( ut == "1")
      {
        const l1 = "Vertical Location of the Flaw, H*  (mm) *";
        const l2 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
       
        if(typaPF == "0")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText1 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
      }

      this.tooltipText2 ="";
      this.tooltipText3 ="";
      this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "2")
    {
      if (ut == "0")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *";
          const l2 = "\nDistance between saddle supports Lss  (inch) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
         
        }
        else if( ut == "1")
        {
          const l1 = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
          const l2 = "\nDistance between saddle supports Lss  (mm) *";
          
        if(typaPF == "0")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText2 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }

        this.tooltipText1 ="";
        this.tooltipText3 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "3")
    {
      if (ut == "0")
        {
          const l1 = "Maximum Operating Temperature, Top  (℉)";
          const l2 = "\nPipe Nominal size, NPS  (inch)";
         
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        else if( ut == "1")
        {
          const l1 = "Maximum Operating Temperature, Top  (℃)";
          const l2 = "\nPipe Nominal size, NPS  (mm)";
          
        if(typaPF == "0")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText3 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
        }
        this.tooltipText1 ="";
        this.tooltipText2 ="";
        this.tooltipText4 ="";
    }
    else if (this.componentService.typearadioselectedValue.toString()== "4")
    {
        if (ut == "0")
          {
            const l1 = "Maximum Operating Temperature, Top  (℉)";
            const l2 = "\nPipe Nominal size, NPS  (inch)";
           
        if(typaPF == "0")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
          }else if(typaPF == "1")
          {
            this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
          }
          }
          else if( ut == "1")
          {
            const l1 = "Maximum Operating Temperature, Top  (℃)";
            const l2 = "\nPipe Nominal size, NPS  (mm)";
           
            if(typaPF == "0")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Passres;
              }else if(typaPF == "1")
              {
                this.tooltipText4 = l1+" = "+a1+"\n"+l2+" = "+a2+Failres;
              }
          }
          this.tooltipText1 ="";
          this.tooltipText2 ="";
          this.tooltipText3 ="";
     }
      else if (this.componentService.typearadioselectedValue.toString()== "5")
      {
          if (ut == "0")
            {
              
            }
            else if( ut == "1")
            {
              
            }
            this.tooltipText1 ="";
            this.tooltipText2 ="";
            this.tooltipText3 ="";
            this.tooltipText4 ="";
      }
      
  }
  updateFormControls() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    applicabilityCheckbox.setValue(true);
   

    let radioButton_DI_formControl = this.getRadioButton_DI_formControl();
    if (Component_MAWP.strD_class === "Blister")
      radioButton_DI_formControl.setValue("radioButton1_DI_enabled");
    else if (Component_MAWP.strD_class === "HIC")
      radioButton_DI_formControl.setValue("radioButton2_DI_enabled");
  }

  BlistersAndHICDamage_Assesment_Setup() {
    //Form1.cpp line: 3124
    Component_MAWP.MAWP_initialize();
    LTA_module.LTA_initialize();
    Component_MAWP.MAWP_initialize();
    BlisterHIC_module.BlisterHIC_initialize();

    Component_MAWP.strD_class = "BlisterHIC";
    Component_MAWP.strD_iclass = 5;
    Component_MAWP.intUnit_select =
      parseInt(localStorage.getItem("unitType")) || 0;
    Form1.prev_strD_class = "Blister";
  }

  handleSummaryData(data: any) {
    this.summary = data;
  }

  handleInspectionData(data: any) {
    this.inspectionDataResult = data;
  }

  calculateResult(): void {
    this.inspectionDataCalculate.next(true);
  }
//shameer
updateApplicabilityCheckboxToUnChecked() {
  let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
  applicabilityCheckbox.setValue(false);
}
  goNextStep() {
    let applicabilityCheckbox = this.getApplicabilityCheckbox_formControl();
    let typeACheckbox = this.gettypeAcheckbox_formControl();
    if ((applicabilityCheckbox.value === true)||(typeACheckbox.value === true))
      localStorage.setItem('calculationStep', (this.myStepper.selectedIndex + 1).toString());

    this.myStepper.next();
  }

  goPreviousStep() {
    localStorage.setItem('calculationStep', (this.myStepper.selectedIndex - 1).toString());
    this.myStepper.previous();
  }

  goToMAWPComponent() {
    let resultFromValidation: boolean = BlisterHIC_module.check_BlisterHIC_TypeOfDamage(
      this.blistersHIC_formGroup
    );
    this.validationList = BlisterHIC_module.validationMessageTypeOfDamage;
    if (!resultFromValidation) return;
    this.goNextStep();
  }

  onChangeRadioButton1_DI(typeOfMetalLoss: string) {
    if (typeOfMetalLoss == "radioButton1_DI_enabled") {
      LTA_module.intLTA_type = 0;
      Component_MAWP.strD_class = "Blister";
    } else {
      LTA_module.intLTA_type = 1;
      Component_MAWP.strD_class = "HIC";
    }
  }
  onRadioChange(event:MatRadioChange)
  {
    if(event.value ==1)
    {
      const dialogRef = this.dialog.open(VerticalvesselComponent,{height : '725px' ,width :'1200px', disableClose :true })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.cancel) {

          this.updateTypeAradioToUncheck();
          this.updateApplicabilityCheckboxToUnChecked();
          this.updatetypeACheckboxToUnChecked();
          this.firstFormGroup.get('applicabilityCheckbox').disable();
          this.firstFormGroup.get('typeACheckbox').disable();
            //clear all tool tips
            this.tooltipText1="";
            this.tooltipText2="";
            this.tooltipText3="";
            this.tooltipText4=""; 

        } else {
          if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
            {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').disable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').enable();

                   //for enabling Reeval button
                   this.isreevalu = false;
                   //for removing tool tips of horizontal /carbon/highalloy  tooltip
                   this.tooltipText2="";
                   this.tooltipText3="";
                   this.tooltipText4="";
   
   
                   //for tooltip on vessels
                   const userinputs = localStorage.getItem('verticalinputs');
                   const Input_data = userinputs ? JSON.parse(userinputs) : null;
                   const a1 = Input_data.inputvalue1;
                   const a2 = Input_data.inputvalue2;
                   
                  this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;
   
                  if(this.intUnittype==0) //us customary
                 {
                   const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                   const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                   const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                   this.tooltipText1 = lbl1+a1+lbl2+a2+res;
                 }
                 else if(this.intUnittype == 1) //si units
                 {
                   const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                   const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                   const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                   this.tooltipText1 = lbl1+a1+lbl2+a2+res;
   
                 }

                 //for typea result in report generation
                 localStorage.setItem("TypeAPassorFail","0");
            
            }
            else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
              {
                this.updateApplicabilityCheckboxToUnChecked();
                this.firstFormGroup.get('applicabilityCheckbox').enable();
                this.updatetypeACheckboxToUnChecked();
                this.firstFormGroup.get('typeACheckbox').disable();

                     //for enabling Reeval button
                     this.isreevalu = false;

                     //for removing tool tips of horizontal /carbon/highalloy  tooltip
                     this.tooltipText2="";
                     this.tooltipText3="";
                     this.tooltipText4="";
     
                     //for tooltip on vessels
                     const userinputs = localStorage.getItem('verticalinputs');
                     const Input_data = userinputs ? JSON.parse(userinputs) : null;
                     const a1 = Input_data.inputvalue1;
                     const a2 = Input_data.inputvalue2;
     
                     this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;
     
                    if(this.intUnittype==0) //us customary
                   {
                     const lbl1 = "\nVertical Location of the Flaw, H (inch) = " ;
                     const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
                     const res = "\n\nThe component meets the Type A screeing criteria."
                     this.tooltipText1 = lbl1+a1+lbl2+a2+res;
                   }
                   else if(this.intUnittype == 1) //si units
                   {
                     const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = " ;
                     const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
                     const res = "\n\nThe component meets the Type A screeing criteria."
                     this.tooltipText1 = lbl1+a1+lbl2+a2+res;
     
                   }
     

                 //for typea result in report generation
                 localStorage.setItem("TypeAPassorFail","1");
              }
        }
     
      }
    });   
    this.componentService.updateTypeASelectedValue(1); // as we selected vertical 
    localStorage.setItem("TypeAradioselection","1"); 
    }
    else if(event.value==2)
    {
      const dialogRef = this.dialog.open(HorizontalvesselComponent,{height : '650px' ,width :'1200px',disableClose :true})
     
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();
              //clear all tool tips
              this.tooltipText1="";
              this.tooltipText2="";
              this.tooltipText3="";
              this.tooltipText4="";

          } else {
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                    //for enabling Reeval button
                this.isreevalu = false;
                //for removing tool tips of vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";
               


                 //for tooltip on vessels
                 const userinputs = localStorage.getItem('horizontalinputs');
                 const Input_data = userinputs ? JSON.parse(userinputs) : null;
                 const a1 = Input_data.inputvalue1;
                 const a2 = Input_data.inputvalue2;

                 this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

               if(this.intUnittype==0) //us customary
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;
              }
              else if(this.intUnittype == 1) //si units
              {
                const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                this.tooltipText2 = lbl1+a1+lbl2+a2+res;

              }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                       //for enabling Reeval button
                this.isreevalu = false;
                //for removing vertical/carbon/highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText3="";
                this.tooltipText4="";

                //for tooltip on vessels
                const userinputs = localStorage.getItem('horizontalinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = " ;
                 const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
                 const res = "\n\nThe component meets the Type A screeing criteria."
                 this.tooltipText2 = lbl1+a1+lbl2+a2+res;
 
               }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(2); // as we selected Horizontal
      localStorage.setItem("TypeAradioselection","2"); 
    }
    else if(event.value==3)
    {
      const dialogRef = this.dialog.open(CarbonsteelandlowalloysteelComponent,{height : '520px' ,width :'1200px',disableClose :true})
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();
            
            //clear all tool tips
            this.tooltipText1="";
            this.tooltipText2="";
            this.tooltipText3="";
            this.tooltipText4="";

          } else {
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();

                           //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /highalloy  tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText4="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('carbonsteelinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText3 = lbl1+a1+lbl2+a2+res;
 
               }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                       //for enabling Reeval button
                       this.isreevalu = false;

                       //for removing tool tips of vertical/horizontal /highalloy  tooltip
                       this.tooltipText1="";
                       this.tooltipText2="";
                       this.tooltipText4="";
       
       
                       //for tooltip on vessels
                       const userinputs = localStorage.getItem('carbonsteelinputs');
                       const Input_data = userinputs ? JSON.parse(userinputs) : null;
                       const a1 = Input_data.inputvalue1;
                       const a2 = Input_data.inputvalue2;
   
                       this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;
   
                      if(this.intUnittype==0) //us customary
                     {
                       const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                       const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                       const res = "\n\nThe component meets the Type A screeing criteria."
                       this.tooltipText3 = lbl1+a1+lbl2+a2+res;
                     }
                     else if(this.intUnittype == 1) //si units
                     {
                       const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                       const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                       const res = "\n\nThe component meets the Type A screeing criteria."
                       this.tooltipText3 = lbl1+a1+lbl2+a2+res;
       
                     }
   

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(3); // as we selected carbon and low alloy
      localStorage.setItem("TypeAradioselection","3"); 
    }
    else if(event.value==4)
    {
       const dialogRef = this.dialog.open(HighalloyandnonferroussteelComponent,{height : '520px' ,width :'1200px', disableClose :true})
       dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.cancel) {

            this.updateTypeAradioToUncheck();
            this.updateApplicabilityCheckboxToUnChecked();
            this.updatetypeACheckboxToUnChecked();
            this.firstFormGroup.get('applicabilityCheckbox').disable();
            this.firstFormGroup.get('typeACheckbox').disable();

             //clear all tool tips
             this.tooltipText1="";
             this.tooltipText2="";
             this.tooltipText3="";
             this.tooltipText4="";

          } else {
            if(result.value[0] == 2 && result.value[1] == false) //typea fail scenario
              {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').disable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').enable();
                      //for enabling Reeval button
                this.isreevalu = false;

                //for removing tool tips of vertical/horizontal /carbon tooltip
                this.tooltipText1="";
                this.tooltipText2="";
                this.tooltipText3="";


                //for tooltip on vessels
                const userinputs = localStorage.getItem('highalloyinputs');
                const Input_data = userinputs ? JSON.parse(userinputs) : null;
                const a1 = Input_data.inputvalue1;
                const a2 = Input_data.inputvalue2;

                this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;

                if(this.intUnittype==0) //us customary
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
               }
               else if(this.intUnittype == 1) //si units
               {
                 const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                 const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                 const res = "\n\nThe component doesn't meet the Type A screeing criteria."
                 this.tooltipText4 = lbl1+a1+lbl2+a2+res;
 
               }

                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","0");
              
              }
              else if(result.value[0] == 2 && result.value[1] == true) //typea pass scenario
                {
                  this.updateApplicabilityCheckboxToUnChecked();
                  this.firstFormGroup.get('applicabilityCheckbox').enable();
                  this.updatetypeACheckboxToUnChecked();
                  this.firstFormGroup.get('typeACheckbox').disable();

                
                  //for enabling Reeval button
                  this.isreevalu = false;

                  //for removing tool tips of vertical/horizontal /carbon tooltip
                  this.tooltipText1="";
                  this.tooltipText2="";
                  this.tooltipText3="";
  
  
                  //for tooltip on vessels
                  const userinputs = localStorage.getItem('highalloyinputs');
                  const Input_data = userinputs ? JSON.parse(userinputs) : null;
                  const a1 = Input_data.inputvalue1;
                  const a2 = Input_data.inputvalue2;
 
                  this.intUnittype = parseInt(localStorage.getItem("unitType")) || 0;
 
                  if(this.intUnittype==0) //us customary
                 {
                   const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = " ;
                   const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
                   const res = "\n\nThe component meets the Type A screeing criteria."
                   this.tooltipText4 = lbl1+a1+lbl2+a2+res;
                 }
                 else if(this.intUnittype == 1) //si units
                 {
                   const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = " ;
                   const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
                   const res = "\n\nThe component meets the Type A screeing criteria."
                   this.tooltipText4 = lbl1+a1+lbl2+a2+res;
   
                 }


                   //for typea result in report generation
                localStorage.setItem("TypeAPassorFail","1");
                }
          }
       
        }
      });
      this.componentService.updateTypeASelectedValue(4);// as we selected HighAlloy
      localStorage.setItem("TypeAradioselection","4"); 
    }
    else
    {        
      if(event.value==5)  // when 2nd radio button is selected , consider typeA as passed
      {
         //for enabling Reeval button
         this.isreevalu = false;

         //clear all tool tips
         this.tooltipText1="";
         this.tooltipText2="";
         this.tooltipText3="";
         this.tooltipText4="";
 
         //for typea result in report generation
         localStorage.setItem("TypeAPassorFail","1");
      }
      
      // when we select 5 or 6 or 7 radio buttons
       this.updateApplicabilityCheckboxToUnChecked();
       this.firstFormGroup.get('applicabilityCheckbox').enable();
       this.updatetypeACheckboxToUnChecked();
       this.firstFormGroup.get('typeACheckbox').disable();
       this.componentService.updateTypeASelectedValue(5); // as we selected Spherical components

       localStorage.setItem("TypeAradioselection","5"); 
    }
   
  }
  updateTypeAradioToUncheck()
  {
    this.firstFormGroup.get('radio').patchValue(null);    
  }

  gettypeAradio_formControl(): FormControl {
    return this.firstFormGroup.get("radio") as FormControl;
  }

  updatetypeACheckboxToChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(true);
  }

  updatetypeACheckboxToUnChecked(){
    let typeAcheckbox = this.gettypeACheckbox_formControl();
    typeAcheckbox.setValue(false);
  }
  gettypeACheckbox_formControl(): FormControl {
    return this.firstFormGroup.get("typeACheckbox") as FormControl;
  }

  typeareevaluate()
  {
    this.updateTypeAradioToUncheck();
    this.updateApplicabilityCheckboxToUnChecked();
    this.updatetypeACheckboxToUnChecked();
    this.firstFormGroup.get('applicabilityCheckbox').disable();
    this.firstFormGroup.get('typeACheckbox').disable();
    
    //for disbling Reeval button
    this.isreevalu = true;
    this.tooltipText1="";
    this.tooltipText2="";
    this.tooltipText3="";
    this.tooltipText4="";
    localStorage.removeItem('verticalinputs');

    
   
  }
}
